export const getJapaneseDayOfWeek = (year: number, month: number, day: number): string => {
  const date = new Date(year, month - 1, day);
  const dayOfWeek = date.getDay();
  const days = ["日", "月", "火", "水", "木", "金", "土"];
  return days[dayOfWeek];
};

export const formatTime = (hour: number | null, minute: number | null): string => {
  if (hour === null || minute === null) return "";
  return `${hour}:${minute.toString().padStart(2, "0")}`;
};

export const formatBuildingShift = (shift: {
  year: number;
  month: number;
  day: number;
  buildingName: string | null;
  startHour: number | null;
  startMinute: number | null;
  endHour: number | null;
  endMinute: number | null;
}): string => {
  const dayOfWeek = getJapaneseDayOfWeek(shift.year, shift.month, shift.day);
  const date = `${shift.year}年${shift.month}月${shift.day}日（${dayOfWeek}）`;
  const building = shift.buildingName || "不明";
  const time =
    shift.startHour !== null && shift.endHour !== null
      ? `${formatTime(shift.startHour, shift.startMinute)} - ${formatTime(shift.endHour, shift.endMinute)}`
      : "";

  return `${date} ${building}${time ? ` / ${time}` : ""}`;
};
